<template>
    <div class="p-2" style="width:250px">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" >
          {{$t('Actual')}} : {{ initialValue }}
        </vs-col>
      </vs-row>
      <div class="vx-row ml-2 mr-2 mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">        
        <vs-row class="mt-2">
          <vs-col class="mb-1" vs-w="12">
            <form-label>{{$t('GradeControl.Timesheet.Destination')}}</form-label>
            <ValidationProvider :name="$t('GradeControl.Timesheet.Destination')" v-slot="{ errors }">
              <v-select
                label="name"
                :options="destinations"
                :reduce="v => v.name"
                v-model="destination"
                @input="setSelected"
                class="w-full"
              />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
            
          </vs-col>
        </vs-row>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { FormLabel } from "./../../../../shared/components";

export default {
  name: 'DestinationCellEditor',
  data() {
    return {
      destination: null,
      locationCode: null,
      timesheetOperationType: null
    }
  },
  computed: {
    destinations() {
      return this.params.context.componentParent.destinations.filter(d => d.name !== this.locationCode);
    },
    initialValue() {
      return this.params.value.destination;
    }
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.timesheetOperationType = this.params.value.timesheetOperationType;
    this.destination = this.params.value.destination;
    this.locationCode = this.params.value.locationCode;
  },
  methods: {
    getValue() {
      const destination = this.destination;
      return {
        destination
      };
    },
    isPopup() {
      return true;
    },
    setSelected(value) {
      if (this.destination !== this.locationCode) {
        this.destination = value;
        this.params.api.stopEditing();
      }
    }
  }
}
</script>